import { PurchaseOrderStatus } from "../../types";

/** Just the two fields overdue depends on — so both the buyer list item and the seller summary fit. */
interface OverdueInput {
  status: PurchaseOrderStatus;
  requestedDeliveryDate: string | null;
}

/** States where delivery is no longer expected — never overdue, whatever the date. */
const TERMINAL_STATUSES: PurchaseOrderStatus[] = [
  "DELIVERED",
  "CANCELLED",
  "REJECTED_SUPPLIER",
  "REJECTED_APPROVER",
];

/**
 * Date-only "strictly before today" (local), the single source of truth for every "past date?"
 * check in the OC flow. The comparison is lexical on the `YYYY-MM-DD` prefix of both dates, so it is
 * free of the timezone drift that parsing a date-only string into a `Date` and reading its local
 * parts would introduce. A null/absent date is never past.
 */
export const isPastDate = (isoDate: string | null | undefined): boolean => {
  if (!isoDate) return false;
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate()
  )}`;
  return isoDate.slice(0, 10) < today;
};

/**
 * An OC is overdue when its requested delivery date is strictly before today and it is still in a
 * state where a delivery is expected. Pure FE rule over the field the list already sends.
 */
export const isOcOverdue = (oc: OverdueInput): boolean =>
  !TERMINAL_STATUSES.includes(oc.status) &&
  isPastDate(oc.requestedDeliveryDate);
